<script>
import ChipColors from '@/app/arch/enums/ChipColors';
import UserStoreAntecipacaoAutoColumnVue from './UserStoreAntecipacaoAutoColumn.vue';

export default {
  name: 'UserStoreAntecipacaoStatusColumn',
  extends: UserStoreAntecipacaoAutoColumnVue,
  computed: {
    hasValue() {
      return !!this.row && typeof this.row.isBlockedStatus === 'boolean';
    },
  },
  methods: {
    getItemLabel(item) {
      return item.value ? 'Bloqueado' : 'Desbloqueado';
    },
    handleItem(item) {
      return {
        ...item,
        ...(item.value ? ChipColors.danger : ChipColors.success),
      };
    },
  },
};
</script>
